export default __webpack_public_path__ + "static/media/queen2.9bd2e67f.png";